import { TicketRepository } from '../repositories/TicketRepository'

export function CreateAssignResponsibilityCase(
  ticketRepository: TicketRepository
) {
  return async function ({
    ticketId,
    personaId
  }: {
    ticketId: string
    personaId: string
  }) {
    return await ticketRepository.createAssignResponsibility({
      ticketId,
      personaId
    })
  }
}
